var _circle, _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#313D53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2043 31.7567V20.526H9.33334V16.195H13.2043V12.7302C13.2043 8.83226 15.6989 6.66675 19.2258 6.66675C20.3441 6.66675 21.5484 6.83999 22.6667 7.01323V10.9978H20.6882C18.7957 10.9978 18.3656 11.9506 18.3656 13.1633V16.195H22.4946L21.8065 20.526H18.3656V31.8264C17.5937 31.9408 16.8038 32.0001 16 32.0001C15.0463 32.0001 14.1121 31.9166 13.2043 31.7567Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#CAF3E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5068 9.44714C52.8121 9.72703 52.8327 10.2015 52.5528 10.5068L41.5528 22.5068C41.4146 22.6576 41.2208 22.7454 41.0163 22.7498C40.8117 22.7543 40.6143 22.675 40.4696 22.5303L35.4696 17.5303C35.1767 17.2374 35.1767 16.7626 35.4696 16.4697C35.7625 16.1768 36.2374 16.1768 36.5303 16.4697L40.9764 20.9158L51.4471 9.49321C51.727 9.18787 52.2014 9.16724 52.5068 9.44714Z",
    fill: "#3CA377"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFacebook);
export default __webpack_public_path__ + "static/media/successFacebook.a739807a972929e6a87f3f1b57ba3cc9.svg";
export { ForwardRef as ReactComponent };